"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const Integration_1 = require("../integrations/Integration");
const type_graphql_1 = require("type-graphql");
const typeorm_1 = require("typeorm");
const ContentFeed_1 = require("./ContentFeed");
const ContentMapping_1 = require("./ContentMapping");
let ContentSystem = class ContentSystem extends Integration_1.Integration {
    constructor() {
        super(...arguments);
        this.integrationType = 'ContentSystem';
        this.displayType = 'Content management system';
    }
};
tslib_1.__decorate([
    type_graphql_1.Field(() => String, { nullable: true }),
    typeorm_1.Column({
        default: '',
        nullable: true,
        type: 'character varying',
    }),
    tslib_1.__metadata("design:type", Object)
], ContentSystem.prototype, "url", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => [ContentFeed_1.ContentFeed]),
    typeorm_1.OneToMany(() => ContentFeed_1.ContentFeed, cf => cf.contentSystem),
    tslib_1.__metadata("design:type", Object)
], ContentSystem.prototype, "contentFeeds", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => [ContentMapping_1.ContentMapping]),
    typeorm_1.OneToMany(() => ContentMapping_1.ContentMapping, cm => cm.contentSystem),
    tslib_1.__metadata("design:type", Object)
], ContentSystem.prototype, "contentMappings", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String),
    tslib_1.__metadata("design:type", String)
], ContentSystem.prototype, "integrationType", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => String),
    tslib_1.__metadata("design:type", Object)
], ContentSystem.prototype, "displayType", void 0);
ContentSystem = tslib_1.__decorate([
    type_graphql_1.ObjectType(),
    typeorm_1.ChildEntity()
], ContentSystem);
exports.ContentSystem = ContentSystem;
// export class ContentSystemEntity extends ContentSystem {
//   public async toEndpoint() {
//     return '/integrations';
//   }
//   public toString() {
//     return this.name;
//   }
// }
//# sourceMappingURL=ContentSystem.js.map